export default __webpack_public_path__ + "static/media/대전청년하우스 입주자 모집 공고문.05e3ddf6.hwp";